// Capped, deduped retry while waiting for reviews.io (it is blocked before
// cookie consent - uncapped polling ran forever).
let reviewsRetries = 0;
let reviewsRetryQueued = false;

function initReviews() {
  if (typeof window.ratingSnippet !== "function") {
    if (reviewsRetryQueued || reviewsRetries >= 100) return;
    reviewsRetryQueued = true;
    reviewsRetries += 1;
    setTimeout(() => {
      reviewsRetryQueued = false;
      initReviews();
    }, 300);
    return;
  }

  const htmlLang =
    document.documentElement.lang ||
    document.body.getAttribute("data-lang") ||
    "en";
  const lang = htmlLang.slice(0, 2);

  const body = document.body;
  const textReviews = body.dataset.textReviews || "Reviews";
  const textReview = body.dataset.textReview || "Review";

  const nodes = document.querySelectorAll(".ruk_rating_snippet");
  if (!nodes.length) return;

  nodes.forEach((el) => {
    if (el.dataset.initialized) return;
    el.dataset.initialized = "true";

    window.ratingSnippet("ruk_rating_snippet", {
      store: "myfroits.shop",
      mode: "default",
      color: "#92A692",
      linebreak: false,
      text: textReviews,
      singularText: textReview,
      lang: lang,
      usePolaris: true,
      showEmptyStars: false,
    });
  });

  setTimeout(tidyCardCounts, 100);
}

/* On phones trim the card review count to a bare number: "(237 Bewertungen)"
   -> "237". The full text is kept in a data attribute and restored when the
   viewport crosses back to tablet width. */
const COUNT_MEDIA = window.matchMedia("(max-width: 767px)");

// Compact contexts always show the bare number, on every viewport:
// PDP cross-sell rows and cart/drawer recommendations.
const ALWAYS_SHORT =
  ".cross-sell .ruk-rating-snippet-count, " +
  ".cross-sells-wrapper .ruk-rating-snippet-count, " +
  ".cart--recommendations .ruk-rating-snippet-count, " +
  ".global-drawer .ruk-rating-snippet-count, " +
  ".global-drawer--secondary__body .ruk-rating-snippet-count";

function tidyCardCounts() {
  const alwaysNodes = new Set(document.querySelectorAll(ALWAYS_SHORT));
  alwaysNodes.forEach((el) => {
    if (!el.dataset.fullText) el.dataset.fullText = el.textContent;
    const m = el.dataset.fullText.match(/\d[\d.,]*/);
    if (m && el.textContent !== m[0]) el.textContent = m[0];
  });
  document.querySelectorAll(".product-grid--rating .ruk-rating-snippet-count").forEach((el) => {
    // drawer/cross-sell counts sit inside .product-grid--rating too - the
    // always-short pass owns them, this viewport-dependent pass must not
    // restore their full text on desktop
    if (alwaysNodes.has(el)) return;
    if (COUNT_MEDIA.matches) {
      if (!el.dataset.fullText) el.dataset.fullText = el.textContent;
      const m = el.dataset.fullText.match(/\d[\d.,]*/);
      if (m && el.textContent !== m[0]) el.textContent = m[0];
    } else if (el.dataset.fullText && el.textContent !== el.dataset.fullText) {
      el.textContent = el.dataset.fullText;
    }
  });
}

if (COUNT_MEDIA.addEventListener) {
  COUNT_MEDIA.addEventListener("change", tidyCardCounts);
}

if (document.readyState === "loading") {
  document.addEventListener("DOMContentLoaded", initReviews);
} else {
  initReviews();
}

document.addEventListener("shopify:section:load", initReviews);

// The cart drawer re-renders its whole content on open/update, detaching
// the node our MutationObserver watches - listen to the theme's eventBus
// events instead and re-init after the fresh nodes settle.
if (window.eventBus && typeof window.eventBus.on === "function") {
  ["open:cart:drawer", "update:cart:drawer", "render:cart:drawer"].forEach((evt) => {
    window.eventBus.on(evt, () => {
      // staggered: the widget fills counts asynchronously from its API
      [350, 1200, 2500].forEach((ms) => setTimeout(initReviews, ms));
    });
  });
}
document.addEventListener("product-recommendations:loaded", initReviews);
document.addEventListener('cart-recommendations:loaded', initReviews);

(function observeRecommendations() {
  const pr = document.querySelector("product-recommendations");
  if (!pr) return;
  initReviews();
  const prObserver = new MutationObserver(() => {
    initReviews();
  });
  prObserver.observe(pr, { childList: true, subtree: true });
})();

// Observe Flow theme recommendations (cart & product)
(function observeFlowRecommendations() {
  const targets = [
    document.querySelector('cart-recommendations'),
    document.querySelector('product-recommendations'),
  ].filter(Boolean);

  targets.forEach((target) => {
    const observer = new MutationObserver((mutations) => {
      for (const mutation of mutations) {
        if (mutation.addedNodes.length > 0) {
          initReviews();
        }
      }
    });
    observer.observe(target, { childList: true, subtree: true });
  });
})();

(function observeCartDrawer() {
  const drawer = document.querySelector("cart-drawer") || document.querySelector(".global-drawer__content");
  if (!drawer) return;

  const observer = new MutationObserver(() => {
    initReviews();
  });

  observer.observe(drawer, { childList: true, subtree: true });
})();
